import { normalizeBetween } from "../../MVC/dataHelpers";
import { generateGradientCircle } from "../../engine/helpers/colors";

class AudioAnalyserBars {
  constructor({ container, stream }) {
    this.container = container;

    const numDivs = 180; // Number of points to distribute around the circle
    const radiusPercent = 50; // Radius of the circle as a percentage
    const centerX = 50; // X-coordinate of the circle's center
    const centerY = 50; // Y-coordinate of the circle's center
    const gradient = generateGradientCircle("#6E98FAFF", "#8E44FD33", numDivs, 180);
    this.bars = [];

    this.audioContext = new AudioContext();
    const audioSource = this.audioContext.createMediaStreamSource(stream);
    const analyser = this.audioContext.createAnalyser();
    analyser.fftSize = 512;
    analyser.smoothingTimeConstant = 0.4;
    audioSource.connect(analyser);
    const volumes = new Uint8Array(analyser.frequencyBinCount);

    for (let i = 0; i < numDivs; i++) {
      const angle = (i / numDivs) * 2 * Math.PI; // Angle from 0 to 2π (full circle)
      const x = centerX + radiusPercent * Math.cos(angle); // Calculate the x-coordinate
      const y = centerY + radiusPercent * Math.sin(angle); // Calculate the y-coordinate

      const div = document.createElement('div');
      div.className = 'circle-div';
      div.style.left = `${x}%`;
      div.style.top = `${y}%`;
      div.style.backgroundColor = gradient[i];
      this.bars.push(div);
      this.container.appendChild(div);

      const updateRotation = (element, angle) => {
        const centerX = 50;
        const centerY = 50;
        const x = parseFloat(element.style.left);
        const y = parseFloat(element.style.top);
        const deltaX = x - centerX;
        const deltaY = y - centerY;
        const rotationAngle = Math.atan2(deltaY, deltaX) + Math.PI / 2;
        element.style.transform = `translate(-50%, -50%) rotate(${rotationAngle}rad)`;
      };
      updateRotation(div, angle);
    }

    if (!this.autoSendVolume) {
      this.autoSendVolume = setInterval(() => {
        analyser.getByteFrequencyData(volumes);
        // let volumeSum = 0;
        this.bars && this.bars.map((plane, i) => {
          const height = 5;
          const val = normalizeBetween(volumes[Math.round(i / numDivs * 40)], 0, 255) * height;
          plane.style.height = `${val * 3}%`;
        })
      }, 50);
    }
  }

  die() {
    clearInterval(this.autoSendVolume);
    this.autoSendVolume = null;
    this.audioContext.close();
    this.bars.forEach(item => {
      $(item).remove();
    });
    this.bars = [];
    this.bars = null;
  }
}
export default AudioAnalyserBars
